/*
 * Copyright (C) 2020 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.config', [])
  /**
   * Service used to access all calls to the config rest service.
   */
  .factory('httpConfigFactory', function ($http) {
    /**
     * Get the current config for the app.
     *
     * @returns {Response|Error} An http response object on success, an Error on failure.
     */
    const getConfig = function () {
      return $http({
        method: 'GET',
        url: 'api/config'
      }).then(function (res) {
        return res.data || {};
      });
    };

    const getBillingUrls = function () {
      return $http({
        method: 'GET',
        url: 'api/config/billing'
      }).then(function (res) {
        return res.data || {};
      });
    };

    return {
      getConfig,
      getBillingUrls
    };
  });
